var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{attrs:{"id":"Header"}},[_c('Cookies'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('Menu',{attrs:{"rotas":_vm.routesComputed}})],1),_vm._v(" "),_c('main',{attrs:{"id":"main"}},[_c('router-view')],1),_vm._v(" "),_c('Footer',{attrs:{"rotas":_vm.routesComputed}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d9696fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 207
// module chunks = 0